/* First-screen access, while retaining the native product form and upload flow. */
(()=>{
  const init=()=>{
    const bar=document.getElementById('ma42-native-buy');
    if(!bar||bar.dataset.ready)return;
    if(document.getElementById('ma5-product')){bar.remove();return;}
    const info=document.querySelector('.product__info-container');
    if(!info)return;
    const getButton=()=>info.querySelector('.main-product-atc');
    if(!getButton())return;
    bar.dataset.ready='true';
    document.body.classList.add('ma42-native-purchase');
    const action=bar.querySelector('[data-ma42-action]'),amount=bar.querySelector('[data-ma42-price]');
    const photo=()=>info.querySelector('.at-photo-choice');
    const isPhotoProduct=document.body.dataset.ma6Template?.includes('photo');
    let observedButton;
    const observer=new IntersectionObserver(entries=>{
      bar.hidden=entries[0].intersectionRatio>=0.8;
    },{threshold:[0,0.8,1],rootMargin:'0px 0px -82px 0px'});
    const sync=()=>{
      const button=getButton();
      if(!button){bar.hidden=true;return;}
      if(button!==observedButton){observer.disconnect();observedButton=button;observer.observe(button);bar.hidden=false;}
      const price=info.querySelector('[id^="price-"] .price')||info.querySelector('.price');
      const source=price?.querySelector(price.classList.contains('price--on-sale')?'.price-item--sale':'.price-item--regular');
      const trioPrice=info.querySelector('.ma40-photo-starting-price');
      if(source)amount.textContent=(trioPrice||source).textContent.trim();
      const isPhoto=isPhotoProduct||Boolean(photo());
      const unavailable=button.dataset.unavailable==='true';
      action.disabled=button.disabled||unavailable;
      action.textContent=isPhoto?bar.dataset.photoLabel:action.disabled?bar.dataset.soldOutLabel:bar.dataset.addLabel;
    };
    action.addEventListener('click',()=>{
      const button=getButton();
      if(!button||action.disabled)return;
      const target=photo();
      if(isPhotoProduct||target){
        if(!target){info.scrollIntoView({block:'start'});return;}
        target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
        const control=target.querySelector('button, input:not([type="hidden"]), [tabindex="0"]');
        control?.focus({preventScroll:true});
      }else button.click();
    });
    new MutationObserver(sync).observe(info,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['disabled','data-unavailable']});
    sync();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
